import { defineComponent as _defineComponent } from 'vue'
import { SSettingsSecurity } from '@slg/web-customer-shared';

const __default__ = {
  name: 'SettingsSecurity',
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {


return { __sfc: true,SSettingsSecurity }
}

})